import { render, staticRenderFns } from "./CreateNewProvider.vue?vue&type=template&id=4e1c0058&scoped=true&"
import script from "./CreateNewProvider.vue?vue&type=script&lang=js&"
export * from "./CreateNewProvider.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewProvider.vue?vue&type=style&index=0&id=4e1c0058&scoped=true&lang=css&"
import style1 from "./CreateNewProvider.vue?vue&type=style&index=1&id=4e1c0058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c0058",
  null
  
)

export default component.exports